import { useEffect, useState } from "react";
import { api } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Builds the Google authorize URL using the current origin's callback path so
// the redirect_uri matches what the backend uses when exchanging the code.
export default function GoogleSignInButton({ label = "continue with Google", testId = "google-signin" }) {
  const [clientId, setClientId] = useState("");
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/auth/google/config");
        if (!active) return;
        setClientId(data.client_id || "");
        setEnabled(!!data.enabled);
      } catch {
        if (active) setEnabled(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const start = () => {
    if (!enabled || !clientId) return;
    const redirect = `${window.location.origin}/auth/google/callback`;
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirect,
      response_type: "code",
      scope: "openid email profile",
      access_type: "online",
      prompt: "select_account",
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  if (!enabled) {
    return (
      <button
        type="button"
        disabled
        title="Google sign-in is not configured"
        className="w-full border border-zinc-800 text-zinc-500 py-2.5 text-sm hover:border-zinc-700 transition-colors cursor-not-allowed flex items-center justify-center gap-2"
        data-testid={testId}
      >
        <GoogleGlyph muted /> {label} · soon
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={start}
      className="w-full border border-zinc-700 hover:border-[#00E5FF] text-zinc-100 py-2.5 text-sm transition-colors flex items-center justify-center gap-2 bg-black"
      data-testid={testId}
    >
      <GoogleGlyph /> {label}
    </button>
  );
}

function GoogleGlyph({ muted = false }) {
  return (
    <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true" style={{ opacity: muted ? 0.5 : 1 }}>
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35.5 24 35.5c-6.4 0-11.5-5.1-11.5-11.5S17.6 12.5 24 12.5c2.9 0 5.5 1 7.6 2.8l5.7-5.7C33.7 6.4 29.1 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 16 18.9 12.5 24 12.5c2.9 0 5.5 1 7.6 2.8l5.7-5.7C33.7 6.4 29.1 4.5 24 4.5c-7.4 0-13.7 4.1-17.1 10.2z"/>
      <path fill="#4CAF50" d="M24 43.5c5 0 9.5-1.7 13-4.6l-6-5C29.1 35.4 26.7 36 24 36c-5.3 0-9.7-3.1-11.3-7.5l-6.5 5C9.6 39.6 16.2 43.5 24 43.5z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.4l6 5c.4-.3 7.2-5.2 7.2-14.4 0-1.2-.1-2.3-.4-3.5z"/>
    </svg>
  );
}
